import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from '@/pages/task-list/styles.less';
import ModuleOverview from '@/common/containers/ModuleOverview/index';
import FirstTimeQuestion from '@/common/containers/FirstTimeQuestion/index';
import {
  useCurrentDecedent,
  useCurrentDecedentId,
  useCurrentDecedentSections,
} from '@/app/providers/DecedentProvider';
import { TASK_MODULES } from '@/common/constants/constants';
import TasksList from '@/common/containers/TasksList/index';
import EditQuestionsAnswers from '@/common/containers/EditQuestionsAnswers/index';
import { useToggle } from '@/common/hooks/index';
import { Storage } from '@/common/utils/index';
import { Tabs } from '@/pages/task-list/components/index';
import {
  TakeBreathe,
  LegalTaskFinished,
  ClosingCautionModal,
} from '@/common/containers/Modals/index';
import Loader from '@/common/components/Loader/index';

const Body = () => {
  const [overview, toggleOverview] = useToggle(false);
  const { tab } = useParams();
  const decedent = useCurrentDecedent();
  const decedentId = useCurrentDecedentId();
  const sections = useCurrentDecedentSections() || {};
  const currentSection = sections?.[tab];
  const question = currentSection?.question;
  const task = currentSection?.task;
  const [showClosingCaution, setShowClosingCaution] = useState(false);

  useEffect(() => {
    if (!Storage.get(`overview.${decedentId}.${tab}`)) {
      toggleOverview(true);
    } else if (overview) {
      toggleOverview(false);
    }
  }, [decedentId, overview, tab, toggleOverview]);

  useEffect(() => {
    if (tab !== TASK_MODULES.CLOSING) {
      setShowClosingCaution(false);
      return;
    }
    if (decedent?.showClosingCaution) {
      setShowClosingCaution(true);
    }
  }, [tab, decedent?.showClosingCaution]);

  const onCloseOverview = useCallback(() => {
    Storage.set(`overview.${decedentId}.${tab}`, 'passed');
    toggleOverview(false);
  }, [decedentId, tab, toggleOverview]);

  const Tasks = useMemo(() => {
    const elements = [<TasksList key="taskList" module={tab} />];

    if (
      currentSection &&
      (tab === TASK_MODULES.LEGAL ? task?.passed : tab !== TASK_MODULES.CLOSING)
    )
      elements.unshift(<EditQuestionsAnswers key="questions" module={tab} />);

    return elements;
  }, [currentSection, tab, task?.passed]);

  if (!currentSection) {
    return <Loader />;
  }

  return (
    <div className={styles.body}>
      <Tabs />
      <div className={styles.bodyContent}>
        <ClosingCautionModal
          open={showClosingCaution}
          onClose={() => setShowClosingCaution(false)}
        />
        {tab === TASK_MODULES.MAIN && question?.passed && <TakeBreathe />}
        {tab === TASK_MODULES.LEGAL && task?.passed && !question?.passed && (
          <LegalTaskFinished />
        )}
        {overview ? (
          <ModuleOverview
            module={tab}
            open={overview}
            onClose={onCloseOverview}
          />
        ) : tab === TASK_MODULES.CLOSING ? (
          <div>{Tasks}</div>
        ) : !question?.passed && tab !== TASK_MODULES.LEGAL ? (
          <FirstTimeQuestion module={tab} />
        ) : (
          <div>{Tasks}</div>
        )}
      </div>
    </div>
  );
};

export default Body;
